<template>
  <el-container>
    <!-- 标题栏 -->
    <el-header>
      <div class="bg-logo">
        <!-- <img
          class="logo-title"
          src="../../assets/img/liveVideo/yx-logo.png"
          alt=""
        /> -->
        <!-- <img
          class="logo-title"
          :src="'data:image/png;base64,' + webLogo"
          alt=""
        /> -->
      </div>
      <div class="title-box">
        <div class="liveVideo-title-txt">{{ this.webTitle }}</div>
        <!-- 当前时间 -->
        <div class="liveVideo-nowTime">{{ nowTime }}</div>
      </div>

      <div class="menu">
        <!-- <el-menu
          mode="horizontal"
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          text-color="#fff"
          active-text-color="#48dacf"
          :unique-opened="false"
          router
          @select="handleSelect"
        >
          <template v-for="item in menuItems">
            <el-submenu
              v-if="item.submenu"
              :key="item.id + ''"
              :index="item.path + ''"
              :default-opened="true"
              class="test1"
            >
              <template slot="title">
                <span @click="toggleSubmenu(item)">{{
                  item.name
                }}</span></template
              >
              <el-menu-item-group>
                <div class="aaa">
                  <el-menu-item
                    v-for="subItem in item.submenu"
                    :key="subItem.id"
                    :index="subItem.path"
                  >
                    {{ subItem.name }}
                  </el-menu-item>
                </div>
              </el-menu-item-group>
            </el-submenu>

            <el-menu-item v-else :key="item.id" :index="item.path">
              {{ item.name }}
            </el-menu-item>
          </template>
        </el-menu> -->

        <!-- 主菜单 -->
        <div class="menu-left-img_box">
          <div class="menu-left-img" v-for="item in menuItems" :key="item.id">
            <div class="liveVideo-title-menu" @click="toggleSubMenu(item)">
              <!-- <div v-if="item.submenu">{{ item.name }}</div> -->
              <router-link
                v-if="item.submenu"
                :to="item.path"
                append
                active-class="menu_ative"
                >{{ item.name }}</router-link
              >
              <router-link v-else :to="item.path" active-class="menu_ative">{{
                item.name
              }}</router-link>
            </div>
          </div>
        </div>
        <!--子菜单 -->
        <div class="subMenu_box">
          <div
            class="subMenu"
            v-show="showSubMenu"
            v-for="subItem in this.subMenu"
            :key="subItem.id"
          >
            <div class="subMenu-name">
              <router-link :to="subItem.path" active-class="subMenu_ative">{{
                subItem.name
              }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <el-dropdown trigger="click">
        <span class="userName">
          <img
            id="user-avatar"
            width="50px"
            height="50px"
            src="../../assets/img/main/user.svg"
            alt=""
          />
          <div class="userNameTile">{{ this.userName }}</div>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>Version：1.1.1</el-dropdown-item>
          <el-dropdown-item divided @click.native="toggleFullScreen">{{
            IsFullscreen === false ? "全屏" : "退出全屏"
          }}</el-dropdown-item>
          <el-dropdown-item
            divided
            @click.native="goDataBoard"
            >返回一张图</el-dropdown-item
          >
          <el-dropdown-item
            divided
            @click.native="openUpdateUserConfigDialogVisible"
            >个人配置</el-dropdown-item
          >
          <!-- <el-dropdown-item @click.native="changePwdDialogVisible = true">修改密码</el-dropdown-item> -->
          <el-dropdown-item divided @click.native="logout"
            >退出登录</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <!-- 路由主页面 -->
    <el-main>
      <router-view></router-view>
    </el-main>
    <!-- 修改个人信息对话框 -->
    <el-dialog
      title="个人配置"
      :visible.sync="UpdateUserConfigDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateUserConfigDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="UserConfigFormRef"
        :model="UserConfigInfo"
        label-width="85px"
      >
        <el-form-item prop="devNo" label="平台标题">
          <el-input
            placeholder="请输入平台标题"
            v-model="UserConfigInfo.userSystemTitle"
            maxlength="12"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="平台LOGO">
          <el-upload
            class="avatar-uploader"
            action="sss"
            list-type="picture-card"
            :class="{ disabled: uploadDisabled }"
            :auto-upload="false"
            :limit="1"
            ref="upload"
            :on-change="handleChange"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- 预览图片 -->
          <el-dialog :visible.sync="dialogVisibleimg" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateUserConfigDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="UpdateUserConfig()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>


<script>
// 页面添加水印效果
const setWatermark = (str) => {
  const id = "1.99654.234";
  if (document.getElementById(id) !== null)
    document.body.removeChild(document.getElementById(id));
  const can = document.createElement("canvas");
  can.width = 200;
  can.height = 130;
  const cans = can.getContext("2d");
  cans.rotate((-20 * Math.PI) / 180);
  cans.font = "20px Vedana";
  cans.fillStyle = "rgba(200, 200, 200, 0.09)";
  cans.textBaseline = "Middle";
  cans.fillText(str, can.width / 10, can.height / 2);
  const div = document.createElement("div");
  div.id = id;
  div.style.pointerEvents = "none";
  div.style.top = "15px";
  div.style.left = "0px";
  div.style.position = "fixed";
  div.style.zIndex = "10000000";
  div.style.width = `${document.documentElement.clientWidth}px`;
  div.style.height = `${document.documentElement.clientHeight}px`;
  div.style.background = `url(${can.toDataURL("image/png")}) left top repeat`;
  document.body.appendChild(div);
  return id;
};

/**

 * 页面添加水印效果
 * @method set 设置水印
 * @method del 删除水印
 */
const watermark = {
  // 设置水印
  set: (str) => {
    let id = setWatermark(str);
    if (document.getElementById(id) === null) id = setWatermark(str);
  },

  // 删除水印
  del: () => {
    let id = "1.99654.234";
    if (document.getElementById(id) !== null)
      document.body.removeChild(document.getElementById(id));
  },
};
import { del } from "vue";
export default {
  data() {
    return {
      // 当前时间
      nowTime: "",
      menuItems: [],
      // 个人配置对话框
      UpdateUserConfigDialogVisible: false,
      // 修改网页logo和标题
      UserConfigInfo: {
        file: "", //网页logo
        userSystemTitle: "", //网页标题
      },
      //上传LOGO查看LOGO对话框
      dialogVisibleimg: false,
      // 上传LOGO查看
      dialogImageUrl: "",
      formdata: new FormData(),
      fileList: [],
      addimg: [],
      // 副标题
      subMenu: [],
      showSubMenu: false,
      currentPath: "",
      userName: "",
      // 系统信息
      SystemSettingValues: [],
      // 平台标题
      webTitle: "",
      // 平台Logo
      webLogo: "",
      // 全屏和非全屏切换
      IsFullscreen: false,
    };
  },
  components: {},
  //监听函数
  watch: {},

  created() {
    this.getMenu();
    // this.getSystemSetting();
    // 获取标题和logo
    this.getSystemTitleAndLogo();
    // 开启水印
    watermark.set(this.userName);
  },
  beforeCreate() {},
  mounted() {
    // 进入获取当前时间
    this.getNowTime();
  },

  computed: {
    uploadDisabled: function () {
      return this.UserConfigInfo.file != "";
    },
  },

  methods: {
    // 获取菜单列表
    getMenu() {
      let value = sessionStorage.getItem("loginInfo"); //字符串或json串
      let json = window.JSON.parse(value); //json串转为js对象
      this.menuItems = json.powerTypeVoList;
      this.userName = json.userName;
      // 修改菜单

      // 如果子菜单为空，这主菜单也过滤掉
      let newMenuItems = this.menuItems.filter((obj) => {
        // console.log("obj.powerVos", obj.powerVos);
        if (obj.powerVos.length > 0) {
          return true; // 如果powerVos为空，过滤掉这个对象
        }
      });

      // 如果子菜单和主菜单一样地址则过滤掉子菜单
      newMenuItems.forEach(function (item) {
        item.powerVos = item.powerVos.filter(function (powerVo) {
          return powerVo.path !== item.path;
        });
      });

      this.menuItems = newMenuItems;
      // 进入main页面后路由(如果第一个主菜单的第一个子菜单没有的话就路由到第一个主菜单，如果有的话则路由到第一个主菜单的第一个子菜单)
      for (let j = 0; j < this.menuItems.length; j++) {
        if (this.menuItems[0].powerVos.length > 0) {
          this.$router.push({ path: this.menuItems[0].powerVos[0].path });
          // 显示子菜单
          this.subMenu = this.menuItems[0].powerVos;
          this.showSubMenu = true;
        } else {
          this.$router.push({ path: this.menuItems[0].path });
        }
      }

      // for (let index = 0; index < this.menuItems.length; index++) {
      //   // 当主菜单的地址和子菜单一样就不显示子菜单
      //     if (
      //       this.menuItems[index].path ===
      //       this.menuItems[index].powerVos[0].path
      //     ) {
      //       delete this.menuItems[index].powerVos;
      //     }
      // console.log("menuItems", this.menuItems);
    },

    handleSelect(index) {
      this.currentPath = index;
    },
    // 获取当前时间
    getNowTime() {
      let speed = 1000;
      let that = this;
      let theNowTime = function () {
        that.nowTime = that.timeNumber();
      };
      setInterval(theNowTime, speed);
    },
    // 格式化时间
    timeNumber() {
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        this.twoDigits(today.getMonth() + 1) +
        "-" +
        this.twoDigits(today.getDate());
      let time =
        this.twoDigits(today.getHours()) +
        ":" +
        this.twoDigits(today.getMinutes()) +
        ":" +
        this.twoDigits(today.getSeconds());
      return date + "  " + time;
    },
    // 时间小于10在前面补0
    twoDigits(val) {
      if (val < 10) return "0" + val;
      return val;
    },
    // 返回数据面板
    goDataBoard() {
      this.$router.push({ path: "/dataBoard" });
    },
    // 返回首页
    backHome() {
      this.$router.push({ path: "/main" });
    },
    // 退出登录
    logout() {
      this.$router.push({ path: "/login" });
      // 清楚session
      sessionStorage.clear();
      // 关闭水印
      watermark.del();
    },
    toggleSubMenu(item) {
      this.subMenu = item.powerVos;
      if (item.powerVos.length > 0) {
        this.$router.push({ path: item.powerVos[0].path }); //主菜单默认跳转到第一个子菜单
        this.showSubMenu = true;
      } else {
        this.showSubMenu = false;
      }

      // 根据菜单项的id获取对应的子菜单数据
      // this.subMenuItems = this.getSubMenuItemsById(id);
      // 切换子菜单的显示与隐藏
    },
    // 获取系统设置参数
    async getSystemSetting() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/setting/search`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.SystemSettingValues = res.data;
        for (let i = 0; i < this.SystemSettingValues.length; i++) {
          // 平台标题
          if (this.SystemSettingValues[i].settingKey == "system_title") {
            this.webTitle = this.SystemSettingValues[i].settingValue;
          }
        }
      }
    },
    // 打开系统标题和logo编辑对话框
    openUpdateUserConfigDialogVisible() {
      this.UpdateUserConfigDialogVisible = true;
      this.UserConfigInfo.userSystemTitle = this.webTitle;
      this.dialogImageUrl = this.webLogo;
      this.UserConfigInfo.file = [this.webLogo];
      this.apply(this.webLogo);
    },
    // 获取系统标题和logo
    async getSystemTitleAndLogo() {
      const { data: res } = await this.$axios.get(`${this.$api}/user/get`);
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.webTitle = res.data.title;
        this.webLogo = res.data.logo;
      }
    },
    // 修改网页标题和LOGO
    async UpdateUserConfig() {
      this.formdata = new FormData();
      //新增
      this.formdata.append("file", this.UserConfigInfo.file); //上传图片要把参数和值放在FormData里
      this.formdata.append(
        "userSystemTitle",
        this.UserConfigInfo.userSystemTitle
      ); //网页标题
      const { data: res } = await this.$axios.post(
        `${this.$api}/user/set/system`,
        this.formdata
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.UpdateUserConfigDialogVisible = false;
      this.$message.success("修改成功");
      location.reload();
    },
    // 关闭个人设置对话框
    clearUpdateUserConfigDialogVisible() {
      this.$refs.UserConfigFormRef.resetFields();
      this.imageUrl = "";
      this.UserConfigInfo.file = "";
      this.UserConfigInfo.userSystemTitle = "";
      this.fileList = [];
    },

    // 添加Logo图片
    handleChange(file, fileList) {
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、png 格式!");
        fileList.splice(-1, 1); //移除错误文件
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 1MB!");
        fileList.splice(-1, 1);
        return false;
      }

      let img = new Image();
      img.src = file.url;
      let _this = this;
      img.onload = (e) => {
        let imgWidth = img.width;
        let imgHeight = img.height;
        if (imgWidth > 100 || imgHeight > 100) {
          _this.$message.error("上传图片宽高不能超过  100px!");
          fileList.splice(-1, 1); //移除错误文件
          return false;
        } else {
          this.addimg = fileList[0].raw;
          this.UserConfigInfo.file = this.addimg;
        }
      };
      // this.addimg = fileList[0].raw;
      // this.UserConfigInfo.file = this.addimg;
    },
    // 删除活动展示照片
    handleRemove(file, fileList) {
      this.$refs.upload.clearFiles(); //清除图片
      this.UserConfigInfo.file = "";
      this.formdata = new FormData();
    },
    // 活动展示照片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleimg = true;
    },
    // 渲染编辑获取id
    apply(res) {
      this.fileList = [{ url: "" }]; //这里是踩坑的点，必须写
      this.fileList[0].url = "data:image/png;base64," + res; //这里是调用接口获取到的值 res.data.flImg，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },

    // 全屏切换
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        this.enterFullScreen();
      } else {
        this.exitFullScreen();
      }
    },
    // 全屏切换
    enterFullScreen() {
      this.IsFullscreen = true;
      let element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        /* Firefox */
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        /* IE/Edge */
        element.msRequestFullscreen();
      }
    },
    // 退出全屏
    exitFullScreen() {
      this.IsFullscreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
  },
};
</script>


<style lang="less" scoped>
.el-menu {
  background-color: transparent;
}
.el-menu-item {
  margin-top: 30px;
  width: 120px;
  height: 35px;
  background-image: url(../../assets/img/liveVideo/menu-box.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-menu-item.is-active {
  color: #409eff;
  background-color: transparent;
}

.el-submenu {
  margin-top: 30px;
  width: 120px;
  height: 35px;
  background-image: url(../../assets/img/liveVideo/menu-box.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/.el-submenu__title {
  width: 120px;
  height: 35px !important;
  line-height: 35px !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
}
/deep/.el-submenu__title:focus,
.el-submenu__title:hover {
  background-color: transparent !important;
}

/deep/.el-submenu__title:hover {
  background-color: transparent !important;
}

/deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: transparent;
}
.el-menu.el-menu--horizontal {
  border-bottom: solid 0px transparent;
  display: flex;
  padding: 0 !important;
  margin: 0 !important;
}

.el-menu-item-group {
  width: 100% !important;
  display: flex !important;
  flex-direction: row !important;
  padding: 0 !important;
  margin: 0 !important;

  .el-menu-item {
    background: none;
    position: relative !important;
    // margin: 20px !important;
    display: flex !important;
    flex-wrap: wrap !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .el-menu-item:hover {
    background-color: #26639d !important;
  }
}

.aaa {
  width: 100% !important;
  display: flex !important;
}

.test {
  display: none !important;
}

/deep/.test1 {
  display: block !important;
}

/* elementui 标题头部样式 */
.el-header {
  background-repeat: no-repeat;
  background-image: url(../../assets/img/liveVideo/liveVideo-title.png);
  background-size: 100% 100%;
  height: 104px !important;
  display: flex;
  justify-content: space-between;
  // display: grid;
  // grid-template-areas:
  //   "bg-logo   liveVideo-title-txt  liveVideo-title-txt menu   menu  menu "
  //   "bg-logo   liveVideo-nowTime liveVideo-nowTime   subMenu subMenu subMenu ";
  // grid-gap: 10px;
}
/* logo背景图 */
.bg-logo {
  width: 120px;
  height: 95%;
  background-repeat: no-repeat;
  // background-image: url(../../assets/img/liveVideo/bg-logo.png);
  background-size: 100% 100%;
  display: flex;
  // flex-grow: 1;
  justify-content: center;
  align-items: center;
}

/* logo */
.logo-title {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
// 标题和时间区域
.title-box {
  display: flex;
  flex-direction: column;
  // width: 20%;
}
/* 标题文本 */
.liveVideo-title-txt {
  color: #48dacf;
  font-size: 1.9rem;
  font-weight: bold;
  margin-top: 20px;
  min-width: 300px;
  display: flex;
  justify-content: center;
}
/* 时间 */
.liveVideo-nowTime {
  color: #00c9b3;
  font-size: 1.5rem;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.el-dropdown {
  height: 50px;
  width: 100px;
  text-align: center;
  margin-top: 20px;
  margin-right: 65px;
  cursor: pointer; /*鼠标放上变小手*/
  // 用户信息
  .userName {
    color: #00c9b3;
    font-size: 1.2rem;
    text-align: center;

    .userNameTile {
      word-break: keep-all; /* 不换行 */
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis !important; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    }
  }
}

/* 菜单 */
.menu {
  display: flex;
  width: 65%;
  flex-direction: column;
  // flex-grow: 4;
  /* flex-wrap: wrap-reverse; */
  // align-items: center;
}

.menu-left-img_box {
  width: 100%;
  display: flex;
}

/* 菜单框 */
.menu-left-img {
  margin-top: 30px;
  width: 120px;
  height: 35px;
  background-image: url(../../assets/img/liveVideo/menu-box.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 菜单栏文本 */
.liveVideo-title-menu {
  color: #48dacf;
  font-size: 1.2rem;
  text-align: center;
  line-height: 40px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  /* cursor: pointer; */
}

/* 菜单栏文本hover事件 */
.liveVideo-title-menu:hover {
  // color: #fff;
  cursor: pointer;
}

.subMenu_box {
  width: 100%;
  display: flex;
  justify-content: center;
}

// 主菜单选中后触发样式
.menu_ative {
  color: #06ffe2;
  border-bottom: 3px solid #06ffe2;
}

/* 子菜单样式 */
.subMenu {
  display: flex;
  justify-content: center;

  // position: relative;
  font-size: 20px;
  // border: 1px solid #097f97;
  // background-color: #00c9b3;
  width: 150px;
  height: 32px;
  margin: 5px 2px 0 2px;
}

.subMenu:hover {
  background-color: #0460b6 !important;
}

/* 子菜单名称 */
.subMenu-name {
  width: 150px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
// 子菜单选中后的样式
.subMenu_ative {
  display: inline-block;
  height: 100%;
  width: 100%;
  // padding:5px 40px;
  background-color: #5680a7;
  text-align: center;
}

// 图片上传样式
/deep/.disabled {
  .el-upload--picture-card {
    display: none;
  }
}

//隐藏上传以及删除时得效果
/deep/.el-upload-list__item {
  transition: none !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Main/main.vue